import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const SquareStackIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.fill || `currentColor`} d="M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2H5a2 2 0 0 1-2-2zm6 12v2h10V9h-2v6a2 2 0 0 1-2 2zm6-2V5H5v10z" />
  </svg>);